module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.newsData.newsContentTitle) ? _c('div', {
    staticClass: "yd-news-button",
    domProps: {
      "textContent": _vm._s(_vm.newsData.newsContentTitle)
    },
    on: {
      "click": function($event) {
        _vm.newsClick(_vm.newsData.newsContentURL)
      }
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-64a634e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/market/common/newsTemplate/Button.vue
// module id = 773
// module chunks = 1